<app-page>
  <get-starter-deso></get-starter-deso>
</app-page>
